// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1E1P5","calendarButtons":"ClockData_calendarButtons__1coPT"};